// Form data setter method. It will pass a key-value pair
// by emitting the "formDataSetter"
export default {
  methods: {
    dataSetter(value, key) {
      this.$emit('formDataSetter', {
        [key]: value
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/form-data-setter.js